import React, { useEffect, useState } from "react";
import "../../profile.css";

import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

const AboutUs = () => {
  const navigate = useNavigate();

  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(false);

  /* =========================
      GET ABOUT US
  ========================= */

  const getAboutUs = async () => {
    try {
      setLoading(true);

      const response = await service.get(
        endpoints.cms.aboutUs,
      );

      setAboutData(response?.data?.data || null);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAboutUs();
  }, []);

  return (
    <div className="info-page">
      <div className="info-page-top">
        <ArrowLeft
          className="back-btn"
          onClick={() => navigate("/contact-info")}
        />

        <h2>About Us</h2>
      </div>

      {loading ? (
        <p className="favourites-loading">
          Loading About Us...
        </p>
      ) : (
        <div className="info-page-content">
          <div className="cms-html-content">
            {aboutData}
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUs;